import { TipoMonedaDto } from "@models/tipoMoneda/tipoMoneda.model";

export class CreateExpedienteRequest {
  public descripcion!: string;
  public observaciones!: string;
  public fechaAlta!: Date;
  public idUsuario!: number;
  public caratula!: string;
  public identificadorUnico!: string;
  public idJuzgado!: number;
  public ubicacion!: string;
  public numeroCarpeta!: string;
  public numeroArchivo!: string;
  public responsable!: string;
  public separadorCaratula!: string;
  public numero!: string;
  public demanda!: string;
  public demandado!: string;
  public causa!: string;
  public activo!: boolean;
  public idEstadoExpediente!: number;
  public idTipoExpediente!: number;
  public claveExpediente!: string;
  public sufijo!: string;
  public bis!: string;
  public fechaIngresoMEU!: Date;
  public montoDemanda!: number;
  public idEstadoProcesal!: number;
  public idCaso!: number;
  public fechaInicio!: Date;
  public fechaFin!: Date;
  public idTipoGrupoExpediente!: number;
  public etiquetas!: string;
  public tokenAcceso!: string;
  public urlGestion!: string;
  public idTipoMonedaMontoDemanda!: number;
  public asignadoA!: number;


}
